import { useState, useEffect } from 'react';

export default function DarkModeToggle() {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [dark]);

  return (
    <button
      type="button"
      onClick={() => setDark((d) => !d)}
      className="w-9 h-9 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors"
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={dark ? 'Light mode' : 'Dark mode'}
    >
      <i className={`${dark ? 'ri-sun-line text-accent-500' : 'ri-moon-line text-foreground-700'} text-lg`} />
    </button>
  );
}